import { render, staticRenderFns } from "./ProductsProfile.vue?vue&type=template&id=5a523dd2"
import script from "./ProductsProfile.vue?vue&type=script&lang=js"
export * from "./ProductsProfile.vue?vue&type=script&lang=js"
import style0 from "./ProductsProfile.vue?vue&type=style&index=0&id=5a523dd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports